
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageSlug]/brand/[brandName]/[...taxonomies]",
      function () {
        return require("private-next-pages/[pageSlug]/brand/[brandName]/[...taxonomies].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageSlug]/brand/[brandName]/[...taxonomies]"])
      });
    }
  